import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';

@Component({
  selector: 'app-traitement-data-frequence-respiratoire-mediane-95',
  standalone: true,
  imports: [
    TraitementDataComponent,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-frequence-respiratoire-mediane-95.component.html',
  styleUrl: './traitement-data-frequence-respiratoire-mediane-95.component.scss'
})
export class TraitementDataFrequenceRespiratoireMediane95Component {
  @Input() patient: Patient | undefined;
}
